import InertiaRootLayout from "@/layouts/InertiaRootLayout"

/**
 * Shared `createInertiaApp` options for the browser entry (`inertia.tsx`)
 * and the SSR entry (`ssr.tsx`).
 *
 * Keep `pages` inline in each entrypoint — `@inertiajs/vite` rewrites it via
 * static AST analysis and cannot see values imported from another module.
 * Keep client-only side effects (Sentry, document checks) out of this module.
 */
export const inertiaAppConfig = {
  layout: () => InertiaRootLayout,

  strictMode: true,

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => {
      return { queryStringArrayFormat: "brackets" as const }
    },
  },
}
